import {IObjectType} from '../../../../index';
import {global} from "../../../../appContext";
import {MutableRuleAbstract} from "./MutableRuleAbstract";
import {IRulePartParams} from "./index";
import {KOSubscriptionTracker} from "../../../../util/KOSubscriptionTracker";

export class RulePart {
    protected readonly et = global.errorAreas.get("ruleset.mutable");
    protected readonly ruleMutable: MutableRuleAbstract;
    protected readonly objectType: KnockoutObservable<IObjectType>;
    protected readonly kosub = new KOSubscriptionTracker();

    constructor(params: IRulePartParams) {
        this.ruleMutable = params.data;
        this.objectType = params.objectType;
    }

    dispose() {
        this.kosub.unsuscribeAll();
    }
}
